/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SqlImportPreviewErrors } from 'cio/utils/sql-import';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { SqlImportsCreateStep } from 'cio/utils/sql-import';

type TransformedError = {
  title: string;
  message: string;
  key: string;
};

function transformError(error: SqlImportPreviewErrors): TransformedError {
  if (error.startsWith('query_not_parseable')) {
    let message = error.replace('query_not_parseable: ', '');
    if (message !== '') {
      return {
        key: 'query_not_parseable',
        title: 'Could not parse your query.',
        message: `Your query returned an error: <strong>${message}</strong>. Make sure your query is valid SQL and try again.`,
      };
    } else {
      return {
        key: 'query_not_parseable',
        title: 'Could not parse your query.',
        message: `Make sure your query is valid SQL and try again.`,
      };
    }
  }

  return {
    id_not_present: {
      key: 'id_not_present',
      title: "We didn't find an id or email selected in your column names.",
      message:
        'You need to select (or map a column to) at least one identifier for people that you import to this workspace.',
    },
    email_not_present: {
      key: 'email_not_present',
      title: "We didn't find an email in your column names.",
      message: 'An email is required to import people in this workspace.',
    },
    forbidden_query: {
      key: 'forbidden_query',
      title: 'We cannot run your query.',
      message:
        'Queries must be read-only. Your query attempts write changes to your database. You must update your query to make it read-only.',
    },
  }[error as Exclude<SqlImportPreviewErrors, 'query_not_parseable'>];
}

interface SqlImportsPreviewErrorsArgs {
  errors: string[];
  changeStep: (step: SqlImportsCreateStep) => unknown;
  sqlImportIsActive: boolean;
}

export default class SqlImportsPreviewErrors extends Component<SqlImportsPreviewErrorsArgs> {
  @service environment!: EnvironmentService;

  steps = SqlImportsCreateStep;
  get transformedErrors() {
    return this.args.errors?.map(transformError);
  }
}
